import {parseISO} from "date-fns";

import {RoomsFilter} from "../constants/rcn_rooms_filter";
import {IPriceReportAveragePrices} from "../types/IPriceReportAveragePrices";
import {findExactMonth} from "./find_exact_month";
import {getAvgPriceM2ForRooms} from "./get_avg_price_m2_for_rooms";
import {getLatestPriceReport} from "./get_latest_price_report";
import {getMedianPriceM2WithYearToYearPercent} from "./get_median_price_m2";
import {calculatePercent, calculatePercentPrecise} from "./percents_handling_helpers";

export interface TrendInsight {
    // null when either anchor (a month ago / a year ago) is missing from the fetched prices window.
    avg: {date: string; priceM2: number; yoyPercent: number; momPercent: number} | null;
    // null when the median (or its year-ago counterpart) isn't renderable - see getMedianPriceM2WithYearToYearPercent.
    median: {date: string; priceM2: number; yoyPercent: number} | null;
}

export const getTrendInsight = (prices: IPriceReportAveragePrices[], rooms: RoomsFilter): TrendInsight | null => {
    const currentMonthData = getLatestPriceReport(prices);

    if (!currentMonthData) {
        return null;
    }

    const currentDate = parseISO(currentMonthData.date);
    const monthAgoData = findExactMonth(prices, 1, currentDate);
    const yearAgoData = findExactMonth(prices, 12, currentDate);
    const currentPriceM2 = getAvgPriceM2ForRooms(currentMonthData, rooms);

    // Needs both anchors - a half-filled sentence (only r/r or only m/m) isn't part of the template.
    const avg =
        monthAgoData && yearAgoData
            ? {
                  date: currentMonthData.date,
                  priceM2: currentPriceM2,
                  yoyPercent: calculatePercent(getAvgPriceM2ForRooms(yearAgoData, rooms), currentPriceM2),
                  momPercent: calculatePercentPrecise(getAvgPriceM2ForRooms(monthAgoData, rooms), currentPriceM2)
              }
            : null;

    const medianWithPercent = yearAgoData ? getMedianPriceM2WithYearToYearPercent(currentMonthData, yearAgoData) : null;
    const median = medianWithPercent ? {date: currentMonthData.date, priceM2: medianWithPercent.price, yoyPercent: medianWithPercent.percent} : null;

    if (!avg && !median) {
        return null;
    }

    return {avg, median};
};
import {parseISO} from "date-fns";

import {RoomsFilter} from "../constants/rcn_rooms_filter";
import {IPriceReportAveragePrices} from "../types/IPriceReportAveragePrices";
import {findExactMonth} from "./find_exact_month";
import {getAvgPriceM2ForRooms} from "./get_avg_price_m2_for_rooms";
import {getLatestPriceReport} from "./get_latest_price_report";
import {getMedianPriceM2WithYearToYearPercent} from "./get_median_price_m2";
import {calculatePercent, calculatePercentPrecise} from "./percents_handling_helpers";

export interface TrendInsight {
    // null when either anchor (a month ago / a year ago) is missing from the fetched prices window.
    avg: {date: string; priceM2: number; yoyPercent: number; momPercent: number} | null;
    // null when the median (or its year-ago counterpart) isn't renderable - see getMedianPriceM2WithYearToYearPercent.
    median: {date: string; priceM2: number; yoyPercent: number} | null;
}

export const getTrendInsight = (prices: IPriceReportAveragePrices[], rooms: RoomsFilter): TrendInsight | null => {
    const currentMonthData = getLatestPriceReport(prices);

    if (!currentMonthData) {
        return null;
    }

    const currentDate = parseISO(currentMonthData.date);
    const monthAgoData = findExactMonth(prices, 1, currentDate);
    const yearAgoData = findExactMonth(prices, 12, currentDate);
    const currentPriceM2 = getAvgPriceM2ForRooms(currentMonthData, rooms);

    // Needs both anchors - a half-filled sentence (only r/r or only m/m) isn't part of the template.
    const avg =
        monthAgoData && yearAgoData
            ? {
                  date: currentMonthData.date,
                  priceM2: currentPriceM2,
                  yoyPercent: calculatePercent(getAvgPriceM2ForRooms(yearAgoData, rooms), currentPriceM2),
                  momPercent: calculatePercentPrecise(getAvgPriceM2ForRooms(monthAgoData, rooms), currentPriceM2)
              }
            : null;

    const medianWithPercent = yearAgoData ? getMedianPriceM2WithYearToYearPercent(currentMonthData, yearAgoData) : null;
    const median = medianWithPercent ? {date: currentMonthData.date, priceM2: medianWithPercent.price, yoyPercent: medianWithPercent.percent} : null;

    if (!avg && !median) {
        return null;
    }

    return {avg, median};
};
